import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M11.996 19.256c-4.132 0-7.558-3.405-7.558-7.51q0-.32.028-.635l6.324.392-2.735 1.878a.142.142 0 0 0 .082.26h11.167c-.859 3.207-3.834 5.615-7.308 5.615m0-15.021c4.13 0 7.557 3.405 7.557 7.51q0 .319-.027.63l-6.318-.399 2.742-1.866a.142.142 0 0 0-.082-.26H4.688c.858-3.207 3.834-5.615 7.308-5.615m10.839 8.35-2.068-.131q.029-.351.029-.708c0-4.83-3.94-8.746-8.8-8.746C7.79 3 4.275 5.932 3.403 9.85H1.78a.33.33 0 0 0-.262.129l-.483.663a.164.164 0 0 0 .13.265l2.06.127q-.03.352-.03.712c0 4.83 3.94 8.745 8.8 8.745 4.206 0 7.722-2.932 8.593-6.85h1.632a.33.33 0 0 0 .262-.129l.483-.663a.164.164 0 0 0-.13-.264"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_brand_opel-C4HLImva.js.map
